function postIframeSize() {
    window.addEventListener('load', function() {
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                window.top.postMessage({
                    width: entry.contentRect.width,
                    height: entry.contentRect.height,
                    'auto-ankauf': 'auto-ankauf'
                }, '*');
            }
        });
        const body = document.querySelector('body');

        resizeObserver.observe(body);
    });
}

function listenForIframeResize() {
    window.addEventListener('message', event => {
        if (!event.data['iframe-autoi-size']) {
            return;
        }

        const {height} = event.data;

        if (height === 0) {
            return;
        }

        document.querySelector('iframe#scf').style.height = height + 'px';
    });
}

export {postIframeSize, listenForIframeResize}
